import _taggedTemplateLiteral from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { Typography } from '../../../style/styled';
import u from './utils';
var Label = styled(Typography)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-weight: ", ";\n   \n    font-size: ", "px;\n    color: inherit;\n\n    &:hover {\n        font-weight: ", ";\n    }\n"])), function (props) {
  return props.weight ? props.weight : 'normal';
}, u.getLabelSize, function (props) {
  return props.hoverWeight ? props.hoverWeight : 'normal';
});
export default {
  Label: Label
};